export default "<p>blog works!</p>\n"